import React, { useState, useEffect, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import { WithApp } from "contexts/appContext";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@material-ui/core/styles";

import Card from "components/Card/Card";
import CardIcon from "components/Card/CardIcon";
import { Assignment } from "@material-ui/icons";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import useItemChanges from "hooks/useItemChanges";

import ModalFull from "components/Tvendo/Common/ModalFull";
//modal imports
import { Polygon } from "@react-google-maps/api";
import wkt from "wkt";
import { getPolygonPath } from "services/PolygonPath";
import { wsUpdate, wsGetAll, wsCreate } from "services/WService";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import GoogleMapCustom from "components/Tvendo/Common/GoogleMapCustom";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  size: {
    fontSize: "4.4rem"
  }
};
const useStyles = makeStyles(styles);

export default WithApp(function ModalNewZone(props) {
  const classes = useStyles();

  const { open, setOpen, zone, setZone, reload, showNotify } = props;
  const [mapRef, setMapRef] = useState(null); //props del mapa cargado
  const [mapCenter, setMapCenter] = useState({
    lat: -14.075411072797454,
    lng: -75.7341740473886
  }); //centro para la carga inicial del mapa
  const polygonRef = useRef(null);

  const handleClose = () => {
    setOpen(false);
    setZone({});
    setNewPolygon({ active: false, paths: null });
    setMapRef(null);
    setMapCenter(undefined);
    setDraggable(false);
  };

  const [newPolygon, setNewPolygon] = useState({ active: false, paths: null });
  const [draggable, setDraggable] = useState(false);

  const [zonesRefference, setZonesRefference] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [dataZone, setDataZone] = useState({});
  const [zoneLoaded, setZoneLoaded] = useState(zone);
  const itemChanges = useItemChanges(zoneLoaded, dataZone);

  const handleChange = (e) => {
    setDataZone({
      ...dataZone,
      [e.target.name]: e.target.value
    });
  };

  async function getZonesReference(zone) {
    let response = await wsGetAll("base/zone");
    if (response.success) {
      for (let i = 0; i < response.data.length; i++) {
        let row = response.data[i];
        if (!!row.geometry) {
          row.geometry = wkt.parse(row.geometry).coordinates[0].map((point) => {
            return {
              lng: point[0],
              lat: point[1]
            };
          });
        }
      }
      if (!!zone) {
        let currentZoneIndex = response.data.findIndex((r) => r.id == zone.id);
        response.data.splice(currentZoneIndex, 1);
        setZonesRefference(response.data);
      }
      setZonesRefference(response.data);
    }
  }

  async function createPolygon() {
    setNewPolygon({
      active: true,
      paths: [
        {
          lat: mapCenter.lat,
          lng: mapCenter.lng
        },
        {
          lat: mapCenter.lat,
          lng: mapCenter.lng + 0.1
        },
        {
          lat: mapCenter.lat - 0.1,
          lng: mapCenter.lng + 0.1
        },
        {
          lat: mapCenter.lat - 0.1,
          lng: mapCenter.lng
        }
      ]
    });
    mapRef.setZoom(10);
  }

  async function savePolygon(dataZoneItems) {
    let wktString;
    if (!!polygonRef.current) {
      let coordinates = getPolygonPath(polygonRef.current);
      if (coordinates.length <= 4) {
        coordinates.push(coordinates[0]);
      }
      wktString = wkt.stringify({
        type: "Polygon",
        coordinates: [coordinates]
      });
    }

    let response;

    if (!!zone.id) {
      response = await wsUpdate("base/zone", zone.id, {
        ...dataZoneItems,
        geometry: wktString
      });
    } else {
      response = await wsCreate("base/zone", {
        ...dataZone,
        geometry: wktString
      });
    }

    if (response.success) {
      showNotify(response.message);
      reload();
      handleClose();
    } else {
      showNotify(response.message, "error");
    }
  }

  function loadDataZone() {
    setDataZone(zone);
    if (zone.geometry !== null)
      setNewPolygon({
        active: true,
        paths: wkt.parse(zone.geometry).coordinates[0].map((point) => {
          return {
            lng: point[0],
            lat: point[1]
          };
        })
      });

    if (!!zone.latitude) {
      setMapCenter({ lat: zone.latitude, lng: zone.longitude });
    } else {
      setMapCenter({
        lat: -14.075411072797454,
        lng: -75.7341740473886
      }); //todo hacer mas validaciones
    }
  }

  async function listWarehouses() {
    let response = await wsGetAll("logi/warehouse");
    if (response.success) setWarehouses(response.data);
  }

  useEffect(() => {
    if (open) {
      if (Object.keys(zone).length > 0) {
        getZonesReference(zone);
        loadDataZone();
        setZoneLoaded(zone);
      } else {
        getZonesReference();
        setDataZone({});
        setMapCenter({
          lat: -14.075411072797454,
          lng: -75.7341740473886
        });
        setNewPolygon({ active: false, paths: null });
      }
      listWarehouses();
    }
  }, [open]);

  return (
    <ModalFull
      title={
        Object.keys(zone).length > 0 ? zone.description : "Registre nueva zona"
      }
      open={open}
      setOpen={handleClose}
    >
      <GridContainer>
        <GridItem xs={12} lg={7}>
          <GridContainer>
            <GridItem xs={12} lg={12}>
              {!newPolygon.active ? (
                !!zone.geometry ? undefined : (
                  <Button
                    onClick={() => createPolygon()}
                    color={props.themeContext.buttonColorSuccess}
                  >
                    Crear Polígono
                  </Button>
                )
              ) : undefined}
            </GridItem>
            <GridItem xs={12} lg={12}>
              <GoogleMapCustom
                onLoad={(map) => {
                  setMapRef(map);
                }}
                options={{
                  disableDoubleClickZoom: true
                }}
                mapContainerStyle={{
                  width: "100%",
                  height: "100%",
                  minHeight: "650px"
                }}
                zoom={11}
                onDragEnd={() => {
                  if (!mapRef) return;
                  setMapCenter({
                    lat: mapRef.center.lat(),
                    lng: mapRef.center.lng()
                  });
                }}
                center={mapCenter}
              >
                {!!newPolygon.paths ? (
                  <Polygon
                    ref={polygonRef}
                    editable={newPolygon.active ? true : false}
                    draggable={newPolygon.active && draggable ? true : false}
                    options={{
                      fillColor: newPolygon.active ? "green" : "red"
                    }}
                    paths={newPolygon.paths}
                    onDblClick={() => setDraggable(!draggable)}
                  />
                ) : undefined}

                {zonesRefference.map((zoneRef, i) => {
                  return !!zoneRef.geometry ? (
                    <Polygon
                      key={i}
                      paths={zoneRef.geometry}
                      options={{
                        fillColor: "red"
                      }}
                    />
                  ) : undefined;
                })}
              </GoogleMapCustom>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12} lg={5}>
          <Card>
            <CardHeader icon>
              <CardIcon color={props.themeContext.buttonColor}>
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Listado de Zonas</h4>
            </CardHeader>
            <CardBody>
              <TextField
                label="Código"
                fullWidth
                margin="normal"
                name="code"
                required
                value={!!dataZone ? dataZone.code || "" : ""}
                onChange={handleChange}
                inputProps={{ maxLength: 2 }}
              />
              <TextField
                label="Descripción"
                fullWidth
                margin="normal"
                name="description"
                required
                value={!!dataZone ? dataZone.description || "" : ""}
                onChange={handleChange}
              />
              <FormControl fullWidth margin="normal">
                <InputLabel>Almacén</InputLabel>
                <Select
                  value={dataZone.logi_warehouse_id || ""}
                  inputProps={{
                    name: "logi_warehouse_id",
                    onChange: handleChange
                  }}
                >
                  {warehouses.map((warehouse, i) => (
                    <MenuItem key={i} value={warehouse.id}>
                      {warehouse.WhsName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                onClick={() => savePolygon(itemChanges)}
                color={props.themeContext.buttonColorSuccess}
              >
                Guardar
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </ModalFull>
  );
});
